<div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light">
    <div class="navbar-container justify-content-between">
        <div class="navbar-brand" href="#">
            <span class="navbar-mobile-title">
                Terms of use
            </span>
        </div>
    </div>
</div>

<div class="container">
    <div class="band pb-5 mt-3 mt-lg-5">
        <div class="row">
            <div class="col">
                <div [innerHTML]="termsOfUse" class="user-content"></div>
                <no-content-message [visible]="termsOfUse.length == 0" message="No terms of use found"></no-content-message>
            </div>
        </div>
    </div>
</div>